import Block from '@/components/Block'
import { SectionGroupLayoutHint, SectionGroupPageSection } from '@/shared/api-generated-types'
import { Tab } from '@headlessui/react'
import React, { useMemo } from 'react'

type Sections = SectionGroupPageSection['sections']

export interface Props extends Pick<SectionGroupPageSection, 'layoutHint' | 'sections'> {
  children: React.ReactNode
  className?: string
}

const getTabbedTitlesFromSections = (sections: Sections): string[] => {
  return sections.map((section, i) => section?.title ?? `Tab ${i}`)
}

const SectionGroupBlock = ({ children, sections, layoutHint, className = '' }: Props): JSX.Element => {
  const tabs = useMemo(() => getTabbedTitlesFromSections(sections), [sections])

  if (layoutHint === SectionGroupLayoutHint.Tab) {
    return (
      <Tab.Group data-component="section-group-block-cp" as="div" className={className}>
        <Tab.List data-headlessui-tab-list>
          {tabs.map((title, i) => (
            <Tab key={i}>{title}</Tab>
          ))}
        </Tab.List>
        <Tab.Panels>
          <div className="pt-lg pt-md-lte-smallTablet">{children}</div>
        </Tab.Panels>
      </Tab.Group>
    )
  } else if (layoutHint === SectionGroupLayoutHint.Stack) {
    // TODO: Might need more control over this later
    // Defaulting to a white block for now
    return (
      <Block
        data-component="section-group-block-cp"
        theme="white"
        className={`${className}px-0 py-0 px-xxs-lte-smallTablet`}
      >
        {children}
      </Block>
    )
  } else {
    return (
      <div data-component="section-group-block-cp" className={className}>
        {children}
      </div>
    )
  }
}
export default SectionGroupBlock
